module.exports = __webpack_public_path__ + "fonts/fa-regular-400.186b1f3.eot";